import script from "./goods-editor-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./goods-editor-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./goods-editor-dialog.vue?vue&type=style&index=0&id=7defceac&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7defceac"]])

export default __exports__